export default "__VITE_ASSET__vhW2788O__"